import { Component, PropTypes, Children, createElement } from 'react';
import Auth0Lock from 'auth0-lock';
import hoistStatics from 'hoist-non-react-statics';
import Auth0 from 'auth0-js';


const TOKEN_KEY = 'cbd-spatial-token';

export const authType = PropTypes.shape({
  loggedIn: PropTypes.bool.isRequired,
  token: PropTypes.string,
  login: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
});

export class AuthProvider extends Component {
  static propTypes = {
    clientId: PropTypes.string,
    domain: PropTypes.string,
    parseImmediately: PropTypes.bool,
    window: PropTypes.shape({
      localStorage: PropTypes.shape({
        setItem: PropTypes.func,
        getItem: PropTypes.func,
      }),
    }),
  }
  static defaultProps = {
    window: window || {},
    clientId: process.env.AUTH0_CLIENT_ID || '',
    domain: process.env.AUTH0_DOMAIN || '',
    parseImmediately: true,
  }
  static childContextTypes = {
    auth: authType,
  }
  getChildContext() {
    return {
      auth: {
        loggedIn: this.loggedIn,
        token: this.token,
        login: this.login,
        logout: this.logout,
      },
    };
  }
  isAuthenticated(token) {
    // Check whether the current time is past the 
    // access token's expiry time
    let expiresAt = token['expires_at'];
    return new Date().getTime() < expiresAt;
  }
  constructor(props, context) {
    super(props, context);
    this.state = {
      parsed: false,
    };

    // This is a really important part of the app. Basically the only point order
    // matters and that you *can't* defer things to the future.
    this.loggedIn = false;
    this.auth = new Auth0.WebAuth({
      clientID: props.clientId,
      domain: props.domain,
      redirectUrl: `${props.window.location.origin}`,
      responseType: 'token',
      // autoParseHash: false,
      params: {
        // This will stop us having to make another request, at the cost of
        // larger tokens. Need to re-evaluate this at some point
        scope: 'openid name nickname email user_metadata app_metadata picture',
      },      
    });

    // because lock doesn't think to handle it's own things
    if (props.parseImmediately) {
      this.parse();
    }
  }
  componentDidMount() {
    this.setState({
      parsed: true,
    });
  }
  getToken() {
    return this.props.window.localStorage.getItem(TOKEN_KEY);
  }
  setToken(token) {
    return this.props.window.localStorage.setItem(TOKEN_KEY, token);
  }
  parse() {
    const { window } = this.props;
    const { hash } = window.location;
    if (hash) {
      // Process it
      this.auth.parseHash(hash, (error, authResult) => {
        if (error || !authResult) {
          throw new Error('Failed to auth. Nothing to do but try reload');
        }

        this.setToken(authResult.idToken);
        // Clear the sensitive info from the URL
        window.history.replaceState(
          '',
          document && document.title || 'title',
          window.location.pathname + window.location.search,
        );
      });
    }

    this.token = this.getToken();
    // When we do have a token
    if (this.token) {
      // Now, we should check if we've got an already expired token
      if (!this.isAuthenticated(this.token)) {
        this.loggedIn = true;
      }
    }
    this.parsed = true;
    
  }
  login = () => {
    
      // Locks are always on the frontdoor
      this.lock = new Auth0Lock(this.props.clientId, this.props.domain, {
        auth: {
          redirectUrl: `${this.props.window.location.origin}`,
          responseType: 'token',
          autoParseHash: false,
          params: {
            // This will stop us having to make another request, at the cost of
            // larger tokens. Need to re-evaluate this at some point
            scope: 'openid name nickname email user_metadata app_metadata picture',
          },
          
        },
        theme:{
          logo: 'https://s3-ap-southeast-2.amazonaws.com/arupdigital-assets/logo.png',
        }
      });
      this.lock.show();
    
  }
  logout = (cb) => {
    this.props.window.localStorage.removeItem(TOKEN_KEY);
    this.loggedIn = false;
    if (cb) {
      cb();
    }
    // this.props.window.location.reload();
  }
  render() {
    
    if (this.state.parsed) {      
      return Children.only(this.props.children);
    }
    return null;
  }
}

export function withAuth(WrappedComponent) {
  class Authenticate extends Component {
    static WrappedComponent = WrappedComponent
    static contextTypes = {
      auth: authType.isRequired,
    }
    render() {
      const props = {
        ...this.context.auth,
        ...this.props,
      };
      return createElement(WrappedComponent, props);
    }
  }
  return hoistStatics(Authenticate, WrappedComponent);
}


// WEBPACK FOOTER //
// ./src/AuthProvider.js